import { use, useEffect, useState } from 'react';
import { AuthContext } from '@/lib/context';
import type { User } from 'firebase/auth';

interface AdminAuthState {
    isAdmin: boolean;
    isLoading: boolean;
    user: User | null;
}

export function useAdminAuth() {
    const auth = use(AuthContext);
    const [state, setState] = useState<AdminAuthState>({
        isAdmin: false,
        isLoading: true,
        user: null
    });

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                try {
                    // Get fresh token with claims
                    const tokenResult = await user.getIdTokenResult(true);
                    const isAdmin = tokenResult.claims.admin === true;
                    
                    setState({
                        isAdmin,
                        isLoading: false,
                        user
                    });
                } catch (error) {
                    console.error('Error checking admin claims:', error);
                    setState({
                        isAdmin: false,
                        isLoading: false,
                        user
                    });
                }
            } else {
                setState({
                    isAdmin: false,
                    isLoading: false,
                    user: null
                });
            }
        });

        return unsubscribe;
    }, [auth]);

    return state;
}
